import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return true;
  }

  // Get sign-out reason if available, otherwise use default
  const reason = authService.getSignOutReason() || 'auth.guard.ts:12 - User not authenticated';
  
  // Sign out and redirect to sign-out page with returnUrl and reason
  authService.signOut(reason, state.url);
  return false;
};

